import React, { Component } from "react";
import { Button, ControlLabel, Modal, Form, FormGroup, FormControl, Glyphicon, Grid, Row, Tooltip, OverlayTrigger, Col } from "react-bootstrap";
import YouTubePlayer  from "../../components/YouTubePlayer";
import "../../css/modal/ModalYouTubeVideo.css";
import "../../css/modal/ModalBasics.css";

export default class ModalYouTubeVideo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pageOverlay:      this.props.pageOverlay,
            showYouTubeModal: this.props.showYouTubeModal,
            exercise_name:    this.props.exercise_name,
            youTubeId:        this.props.youTubeId,
            exerciseDetailsObj: this.props.exerciseDetailsObj,
        };
    }

    componentWillReceiveProps (nextProps) {
        //console.log("2. Youtube Modal componentWillReceiveProps!!!");
        this.setState({
            pageOverlay:      nextProps.pageOverlay,
            showYouTubeModal: nextProps.showYouTubeModal,
            exercise_name:    nextProps.exerciseName,
            youTubeId:        nextProps.youTubeId,
        })
    }

    /*showYouTubeModal = (event, yt_id, exercise_name) => {
        this.setState({
            youTubeId: yt_id,
            pageOverlay: "inline",
            showYouTubeModal: true,
            exercise_name: exercise_name
        })
    }*/

    handleCloseYouTubeWin = () => {
        this.setState({
            pageOverlay: "none",
            showYouTubeModal: false,
            exercise_name: "",
            youTubeId: ""
        });

        this.props.closeYouTubeWin();
    }


    createMarkup (text) {
        var new_text = text.replace(/\\r\\n/g, "<br/>"); // replace '\r\n'
        return {__html: new_text};
    };


    render() {
        var pageOverlay      = this.state.pageOverlay;
        var showYouTubeModal = this.state.showYouTubeModal;
        var youTubeId        = this.state.youTubeId;
        var show_summary     = this.props.showSummary;
        var exercise_name    = this.state.exercise_name;
        var start            = ""; //this.state.exerciseDetailsObj.start;
        var execute          = ""; //this.state.exerciseDetailsObj.execute;
        var focus            = ""; //this.state.exerciseDetailsObj.focus;
        var goal             = ""; //this.state.exerciseDetailsObj.goal;

        if(this.state.exerciseDetailsObj != undefined) {
            exercise_name    = this.state.exerciseDetailsObj.name;
            start            = this.state.exerciseDetailsObj.start;
            execute          = this.state.exerciseDetailsObj.execute;
            focus            = this.state.exerciseDetailsObj.focus;
            goal             = this.state.exerciseDetailsObj.goal;
        }
        var sorry_text       = "";
        var summary;
        var title;

        if(exercise_name != undefined) title = exercise_name;
        
        if(youTubeId === "") sorry_text = "Sorry, there's no Youtube video."

        if(show_summary != false)
            summary = <span>
                            <div></div>
                            <div className="modalYTVideoSectionTitle">
                                <b>START</b>
                                <div dangerouslySetInnerHTML={this.createMarkup(start)}/>
                            </div>
                            <div className="modalYTVideoSectionTitle">
                                <b>EXECUTE</b>
                                <div dangerouslySetInnerHTML={this.createMarkup(execute)}/>
                            </div>
                            <div className="modalYTVideoSectionTitle">
                                <b>FOCUS</b>
                                <div dangerouslySetInnerHTML={this.createMarkup(focus)}/>
                            </div>
                            <div className="modalYTVideoSectionTitle">
                                <b>GOAL</b>
                                <div dangerouslySetInnerHTML={this.createMarkup(goal)}/>
                            </div>
                      </span>
        return (
            <div>
                <span className="pageOVerlay" style={{display:pageOverlay}}></span>
                <Modal
                       show={showYouTubeModal}
                       onHide={() => this.handleCloseYouTubeWin()}
                       aria-labelledby="contained-modal-title"
                     >
                       <Modal.Header closeButton>
                         <Modal.Title id="contained-modal-title">
                           { title }
                         </Modal.Title>
                       </Modal.Header>
                       <Modal.Body>
                         <div style={{width:"570px", height:"280px", backgroundColor:"#ccc"}}>
                             <span style={{position:"relative", top:"20px", left: "20px"}}>{sorry_text}</span>
                             <YouTubePlayer yt_id={youTubeId} />
                         </div>
                         { summary }

                       </Modal.Body>
                       <Modal.Footer>
                           <Button className="modalBasicsBtnClose" onClick={() => this.handleCloseYouTubeWin()}>Close</Button>
                       </Modal.Footer>
                 </Modal>
          </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalYouTubeVideo.js